import { useQuery } from '@tanstack/react-query';

import { blogService } from '@/services/blog-service';
import type {
  BlogPost,
  BlogPostsPayload,
  BlogPostsRequest,
  BlogTagsPayload,
  BlogTagsRequest,
} from '@/types/blog';
import { BLOG_TENANT_ID } from '@/utils/blog-config';
import { BLOG_QUERY_KEYS } from '@/utils/query-keys';

export const useBlogPosts = (request: BlogPostsRequest) =>
  useQuery<BlogPostsPayload, Error>(
    BLOG_QUERY_KEYS.posts(request),
    () => blogService.getPosts(request),
    {
      enabled: Boolean(BLOG_TENANT_ID),
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );

export const useBlogTags = (request: BlogTagsRequest) =>
  useQuery<BlogTagsPayload, Error>(
    BLOG_QUERY_KEYS.tags(request),
    () => blogService.getTags(request),
    {
      enabled: Boolean(BLOG_TENANT_ID),
      staleTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );

export const useBlogPost = (
  postId: number | string | undefined,
  variant: BlogPostsRequest['variant']
) =>
  useQuery<BlogPost, Error>(
    BLOG_QUERY_KEYS.detail(variant, postId),
    () => blogService.getPost(postId as number | string, variant),
    {
      enabled: Boolean(BLOG_TENANT_ID && postId),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );
